export var CanPlaySource;!function(a){a.PROBABLY="probably",a.MAYBE="maybe",a.NO=""}(CanPlaySource||(CanPlaySource={}));